import { createGlobalStyle } from "styled-components";

export const AppStyle = createGlobalStyle`
    body, html {
        margin: 0px;
        padding: 0px;
    }

    html body div#root header > div > div > h1 {
        max-height: 30px;
        overflow: hidden;
    }

    body {
        font-family: "Montserrat", sans-serif;
    }

    h1 {
        font-size: 30px;
        font-weight: 700;
        margin: 15px 0px;
        color: #000;
    }

    h2 {
        font-size: 26px;
        font-weight: 700;
        margin: 15px 0px;
        color: #000;
    }
`;
